import { AuthPasswordForm } from '@command-center/ui-system';
import { useAuth } from './AuthProvider';
import type { PasswordEmailAction } from './email-auth-flow';

export function ResetPasswordForm({ action }: { action: PasswordEmailAction }) {
  const { updatePassword, completePasswordUpdate } = useAuth();

  async function submit(password: string) {
    const result = await updatePassword(password);
    if (!result.ok) return result;
    await completePasswordUpdate();
    return { ok: true as const };
  }

  return (
    <AuthPasswordForm
      title={action === 'invite' ? 'Create your password' : 'Choose a new password'}
      submitLabel={action === 'invite' ? 'Create password' : 'Update password'}
      onSubmit={submit}
    />
  );
}
